//#region import libraries
import React, { useEffect, useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectAdditionalPassengers, setAdditionalPassengers } from '_redux/slices/prm-bookings/bookings';
import { selectPostedBookingsStatus, resetAdditionalPassengers, selectPostBookingListError, selectDuplicatedCombinedBookings, selectTimelineDeparturesBookingList, setDuplicatedCombinedBookings, selectBookingsByFlight } from "_redux/slices/timeline/timeline-data";
import { selectDefaultCheckInLocation } from '_redux/slices/timeline/timeline-control';
import { selectPickUpLocations } from '_redux/slices/timeline/timeline-areas';
import { selectIata, selectUserDb } from '_redux/slices/main-screen/user';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// CUSTOM COMPONENTS
import { CustomSpinner, Label } from '_atoms';
import { AssistanceSelector } from '_molecules';

// bootstrap
import { Form, Button } from 'react-bootstrap';

// iconn
import { MdError } from 'react-icons/md';

// styling
import { Colors } from "_styles";

// drop down menu
import Select from "react-select";

//#endregion

//#region pax info
const PassengerInformationForm = ({ passenger, index, setFirstName, setSecondName, setAssistance, setPickUpLocation, pickUpLocations, flightType, setErrorMessage, setAmbiliftRequired }) => {

    const defaultCheckInLocation = useSelector(selectDefaultCheckInLocation);                     //Defaul checkIn location...
    const usedTheme = useSelector(selectUsedTheme);
    const iata = useSelector(selectIata)
    // check if there is a defaultCheckInLocation setSelectedPickUp by default as the defaultCheckInLocation
    const [selectedPickUp, setSelectedPickUp] = useState(null)

    useEffect(() => {
        if (defaultCheckInLocation) {
            const tempLocation = pickUpLocations?.find(loc => loc?._id === defaultCheckInLocation)
            setSelectedPickUp({
                value: tempLocation?._id ?? "",
                label: tempLocation?.title ?? ""
            })
            setPickUpLocation(defaultCheckInLocation, index)
        };
    }, []);


    const handleChangeName = (type, inputValue, key) => {

        const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;

        //Validate and set field-specific error
        let msg = "";
        if (inputValue.trim() === "") {
            msg = "This field is required";
        } else if (!nameRegex.test(inputValue)) {
            msg = "Name must only contain letters, spaces, hyphens, and apostrophes";
        }

        if (type === "firstName") setFirstName(inputValue, key);

        if (type === "secondName") setSecondName(inputValue, key)
        setErrorMessage(msg)
    }


    return (
        <>
            <style>
                {`
        .form-input::placeholder {
        color: ${usedTheme.TEXT_COLOR} !important;
        opacity: 1;
        }
        `}
            </style>
            <div key={index} style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ width: "100%" }}>

                        {/* first name + last name */}
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ width: "45%" }}>
                                <Label>First Name</Label>
                                <Form.Control className="form-input" type="text" placeholder="Passenger first name" onChange={(e) => handleChangeName("firstName", e.target.value, index)} value={passenger?.firstName}
                                    style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR, color: usedTheme.TEXT_COLOR }} />
                            </div>

                            <div style={{ width: "45%" }}>
                                <Label>Second Name</Label>
                                <Form.Control className="form-input" type="text" placeholder="Passenger second name" onChange={(e) => handleChangeName("secondName", e.target.value, index)} value={passenger?.secondName}
                                    style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR, color: usedTheme.TEXT_COLOR }} />
                            </div>
                        </div>

                        {/* Assistance selector */}
                        <div className='mt-5'>
                            <Label>Assistance</Label>
                            <AssistanceSelector setAssistance={(e) => { setAssistance(e, index) }} defaultValue={[]} value={passenger?.assistance} />
                        </div>
                        {iata === "PUJ" && <div className='mt-5'>
                            <Label>Ambilift Required</Label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                <Form.Check
                                    type="switch"
                                    onChange={(e) => { setAmbiliftRequired(e.target.checked, index) }}
                                    checked={!!passenger?.ambiliftRequired}
                                />
                                <span style={{ fontSize: 13, color: passenger?.ambiliftRequired ? Colors.DARK_GREEN : Colors.GRAY_DARK, fontWeight: 500 }}>
                                    {passenger?.ambiliftRequired ? 'Yes' : 'No'}
                                </span>
                            </div>
                        </div>}

                        {/* Pick up locations, in case departure flight */}
                        {flightType === "departure" && (
                            <div className='mt-5 d-grid'>
                                <Label>Pick Up Location (Optional)</Label>
                                <Select
                                    value={selectedPickUp || null}
                                    onChange={(selectedOption) => {
                                        setSelectedPickUp(selectedOption);
                                        setPickUpLocation(selectedOption?.value, index);
                                    }}
                                    options={pickUpLocations?.map(loc => ({
                                        value: loc._id,
                                        label: loc.title
                                    }))}
                                    placeholder="Choose Pick Up Location..."
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minWidth: "25%",
                                            borderRadius: "5px",
                                            backgroundColor: usedTheme.BACKGROUND_COLOR,
                                            borderColor: usedTheme.BORDER_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: usedTheme.TEXT_COLOR,
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: usedTheme.TEXT_COLOR,
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            backgroundColor: usedTheme.BACKGROUND_COLOR,
                                            borderColor: usedTheme.BORDER_COLOR,
                                            color: usedTheme.TEXT_COLOR
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused
                                                ? usedTheme.BORDER_COLOR
                                                : usedTheme.BACKGROUND_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                            cursor: 'pointer',
                                        }),
                                    }}
                                    isClearable
                                />
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </>
    )
}
//#endregion

//#region add pax
const AdditionalPassengerForm = (props) => {

    //#region redux
    const dispatch = useDispatch();

    // usr
    const dbUser = useSelector(selectUserDb)

    const additionalPassengers = useSelector(selectAdditionalPassengers);                               // additional Passengers to be added to flight 
    const postedBookingStatus = useSelector(selectPostedBookingsStatus)                                 // status of post request
    const pickUpLocations = useSelector(selectPickUpLocations);                                         // list of pick up locations        
    const postBookingError = useSelector(selectPostBookingListError);                                   // error message from post request                 
    const duplicatedCombinedBookings = useSelector(selectDuplicatedCombinedBookings);                   // list of duplicated bookings
    const timelineDeparturesBookingList = useSelector(selectTimelineDeparturesBookingList);             // list of all departure bookings in timeline
    const allBookingsByFlight = useSelector((state) => selectBookingsByFlight(state, true))    //#endregion

    //#region local state
    const [errorMessage, setErrorMessage] = useState(null);                 // holds error message
    const [additionalBoard, setAdditionalBoard] = useState(false);          // additional boarding or only boarding
    //#endregion

    //#region form handlers 

    //#region passenger name

    // save first name in the pax object 
    const setFirstName = (value, index) => {
        let tempList = [...additionalPassengers];                                       // copy list
        const newObj = Object.assign({}, tempList[index], { firstName: value });        // create a new object with a writable firstName property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))
    }

    // save last name in pax object
    const setSecondName = (value, index) => {
        let tempList = [...additionalPassengers];                                        // copy list
        const newObj = Object.assign({}, tempList[index], { secondName: value });        // create a new object with a writable secondName property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))
    }
    //#endregion

    //#region assistance handling

    // save selected assistance as assistance key
    const setAssistance = (value, index) => {
        let tempList = [...additionalPassengers];                                         // copy list
        const newObj = Object.assign({}, tempList[index], { assistance: value });        // create a new object with a writable assistance property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))

    }

    //#endregion

    //#region Ambilift Required handling
    // save ambiliftRequired as ambiliftRequired key
    const setAmbiliftRequired = (value, index) => {
        let tempList = [...additionalPassengers];                                         // copy list
        const newObj = Object.assign({}, tempList[index], { ambiliftRequired: value });        // create a new object with a writable assistance property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))
    }

    //#endregion

    //#region pick up location      
    // add locationInfo into pax object
    const setPickUpLocation = (value, index) => {
        // check if there is no value the remove locationInfo from teh passenger object
        if (!value) {
            let tempList = [...additionalPassengers];               // copy list
            let newObj = Object.assign({}, tempList[index]);        // create a new object with a writable locationInfo property
            if (newObj?.locationInfo) delete newObj?.locationInfo;
            tempList[index] = newObj;                               // update list with new object
            dispatch(setAdditionalPassengers(tempList))
        } else {
            const locationInfo = {
                locationId: value,
                locationTitle: pickUpLocations?.find((pickUp) => value == pickUp?._id)?.title,
                activity: "Checked-in",
                time: new Date()
            }
            let tempList = [...additionalPassengers]; // copy list
            const newObj = Object.assign({}, tempList[index], { locationInfo });        // create a new object with a writable locationInfo property
            tempList[index] = newObj; // update list with new object
            dispatch(setAdditionalPassengers(tempList))
        }
    }
    //#endregion

    //#region duplicate booking
    const handleDuplicate = () => {
        // find flight in allBookingsByFlight for the current flight
        let wantedFlightKey = props?.flight?.replace('_', '/boarding_');
        const targetKey = Object?.keys(allBookingsByFlight)?.find(key => key.startsWith(wantedFlightKey));

        // filter allBookingsByFlight for the current flight and that is not duplicateVersion
        let filteredBooking = allBookingsByFlight?.[targetKey]?.filter((booking) => !booking?.duplicateVersion)?.[0];
        // check if filteredBooking is an object
        if (!Object.isObjectEmpty(filteredBooking)) {
            let tempBooking = { ...filteredBooking }
            let originalCombinedBookingList = Array.isFullArray(duplicatedCombinedBookings) ? [...duplicatedCombinedBookings] : []
            let duplicateVersion = 1;           // initally, all duplicates are part-1

            // use duplicate list to count number of duplicates for this boarding pass
            if (duplicatedCombinedBookings && duplicatedCombinedBookings.length > 0) {
                let tempDuplicates = duplicatedCombinedBookings.filter(item => item.doc._id.startsWith(tempBooking._id));
                if (tempDuplicates && tempDuplicates.length > 0) {
                    duplicateVersion = tempDuplicates.length + 1;
                }
            }

            tempBooking.duplicateVersion = duplicateVersion;

            let newId = tempBooking._id + "-part" + duplicateVersion;

            let newDuplicate = { doc: tempBooking, id: newId };
            newDuplicate.doc._id = newId;

            originalCombinedBookingList.push(newDuplicate);
            dispatch(setDuplicatedCombinedBookings(originalCombinedBookingList));
        };
    }
    //#endregion

    //save pax after clicking add passsenger
    const handleAddBooking = () => {
        // check if there is a first name and last name and assistance
        props?.addBooking(additionalBoard);
    }
    //#endregion

    //#region useEffect
    // reset
    useEffect(() => {
        dispatch(resetAdditionalPassengers());
    }, []);

    // ha
    useEffect(() => {
        if (postedBookingStatus === "succeeded" && (additionalBoard === "additionalBoarding" || additionalBoard === "onlyBoarding")) {
            handleDuplicate();
        }
    }, [postedBookingStatus, additionalBoard, timelineDeparturesBookingList]);

    // handling error message
    useEffect(() => {
        if (postedBookingStatus === "failed" && postBookingError) {
            setErrorMessage(postBookingError)
        }
    }, [postedBookingStatus]);
    //#endregion

    return (
        <div style={{ display: "grid" }}>

            {/* pax name + assistance + pick-up locations */}
            {additionalPassengers?.map((passenger, index) => {
                return (
                    <PassengerInformationForm
                        passenger={passenger}
                        index={index}
                        setFirstName={setFirstName}
                        setSecondName={setSecondName}
                        setAssistance={setAssistance}
                        setPickUpLocation={setPickUpLocation}
                        pickUpLocations={pickUpLocations}
                        flightType={props.type}
                        setErrorMessage={setErrorMessage}
                        setAmbiliftRequired={setAmbiliftRequired}
                    />
                )
            })
            }

            {/* Boarding options */}
            {dbUser && dbUser.details && dbUser.details?.authority != 'JER' && props.type === "departure" ?
                <Form className='mt-5'>
                    <Form.Label className="m-0" style={{ color: Colors.PRM_LIGHT_BLUE }}>Boarding Options</Form.Label>
                    <div style={{}}>
                        <div className='d-flex align-items-center'>
                            <Form.Check inline type="radio" checked={additionalBoard == "additionalBoarding"} onChange={() => setAdditionalBoard("additionalBoarding")} />
                            <Form.Check.Label style={{ marginTop: ".25em" }}>Additional Boarding</Form.Check.Label>
                        </div>
                        <div className='d-flex align-items-center'>
                            <Form.Check inline type="radio" checked={additionalBoard == "onlyBoarding"} onChange={() => setAdditionalBoard("onlyBoarding")} />
                            <Form.Check.Label style={{ marginTop: ".25em" }}>Only Boarding</Form.Check.Label>
                        </div>
                        <div className='d-flex align-items-center'>
                            <Form.Check inline type="radio" checked={additionalBoard == ""} onChange={() => setAdditionalBoard("")} />
                            <Form.Check.Label style={{ marginTop: ".25em" }}>None</Form.Check.Label>
                        </div>
                    </div>
                </Form>
                : null}

            {/* Adding passenger button */}
            <div className='mt-5' style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outline-primary" onClick={handleAddBooking} style={{ width: 200 }} disabled={!additionalPassengers?.[0]?.firstName || !additionalPassengers?.[0]?.secondName || !Array.isFullArray(additionalPassengers?.[0]?.assistance) || errorMessage}>
                    {postedBookingStatus === "loading" ? <CustomSpinner /> : "Add Passenger"}
                </Button>
            </div>
            {errorMessage && <div style={{ display: 'flex' }}><MdError color={'red'} size={22} /><p style={{ color: 'red' }}>{errorMessage}</p></div>}

        </div>
    );

};
//#endregion

export default AdditionalPassengerForm;